import Styles from './button-bordered-red-styles.scss';
import React from 'react';
const ButtonBorderedRed = ({ onClick, disabled = false, btnBackgroundGradient = 'transparent', text = 'Back', border = 'red' }) => {
    return (React.createElement("div", { className: Styles.wrapper },
        React.createElement("button", { disabled: disabled, className: Styles.button, style: disabled
                ? {}
                : {
                    border: border === 'red' ? '1px solid #f04a4a' : '1px solid #4caf50'
                }, onClick: onClick },
            React.createElement("div", { className: Styles.buttonContent },
                React.createElement("h4", { className: Styles.text, style: disabled
                        ? {
                            color: 'gray'
                        }
                        : {
                            color: border === 'red' ? '#f04a4a' : ' #4caf50'
                        } }, text)))));
};
export default ButtonBorderedRed;
